import { Search } from "lucide-react";
import { Input } from "../../../../components/ui/common/input";
import IngredientFilterPanel from "./IngredientFilterPanel";

interface IngredientListToolbarProps {
  searchKey: string;
  onSearchChange: (value: string) => void;
  refetchWithFilters: (
    ingredientIds: string[],
    supplierIds: string[],
    dataTypeIds: string[],
    sortBy: number
  ) => void;
}

/**
 * Search + filter row, styled after the Recipe Simulator search bar
 * (src/screens/recipe_simulator/newList/components/RecipeListSearch.tsx):
 * a relative-positioned box with an absolutely-positioned icon and the
 * common `Input` padded clear of it.
 */
const IngredientListToolbar = ({
  searchKey,
  onSearchChange,
  refetchWithFilters
}: IngredientListToolbarProps) => {
  return (
    <div className="tw-mb-4 tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-center">
      <div className="tw-relative tw-w-full sm:tw-w-72">
        <Search
          size={16}
          className="tw-pointer-events-none tw-absolute tw-left-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-muted-foreground"
        />
        <Input
          value={searchKey}
          onChange={e => onSearchChange(e.target.value)}
          placeholder="Search ingredient name"
          className="tw-pl-9"
        />
      </div>
      <IngredientFilterPanel refetchWithFilters={refetchWithFilters} />
    </div>
  );
};

export default IngredientListToolbar;
